import { render, staticRenderFns } from "./CreateForum.vue?vue&type=template&id=158c1dc8&scoped=true"
import script from "./CreateForum.vue?vue&type=script&lang=js"
export * from "./CreateForum.vue?vue&type=script&lang=js"
import style0 from "./CreateForum.vue?vue&type=style&index=0&id=158c1dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158c1dc8",
  null
  
)

export default component.exports